import { render, staticRenderFns } from "./SetupVerifyEmail.vue?vue&type=template&id=db9684de"
import script from "./SetupVerifyEmail.vue?vue&type=script&lang=js"
export * from "./SetupVerifyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports